import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon/index.js';

const Badge = ({
  iconLeft,
  iconRight,
  className,
  label,
  variant,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("span", Object.assign({
  className: cx("tds-badge", "slds-badge", "slds-grid_vertical-align-center", className, variant && `tds-badge_${variant}`, size && `tds-badge_${size}`)
}, props), iconLeft && /*#__PURE__*/React.createElement(Icon, {
  assistiveText: {
    label: iconLeft.assistiveText
  },
  name: iconLeft.name,
  size: "xx-small",
  className: "slds-m-right_xx-small slds-m-bottom_xx-small"
}), label, iconRight && /*#__PURE__*/React.createElement(Icon, {
  assistiveText: {
    label: iconRight.assistiveText
  },
  name: iconRight.name,
  size: "xx-small",
  className: "slds-m-left_xx-small slds-m-bottom_xx-small"
}));
Badge.displayName = "Badge";
Badge.propTypes = {
  /**
   * CSS class added to the main `<span />` element.
   */
  className: PropTypes.string,
  /**
   * The text of the badge.
   */
  label: PropTypes.string.isRequired,
  /**
   * The type badge.
   */
  variant: PropTypes.oneOf(["default", "danger", "success"]),
  /**
   * The size of the badge text.
   */
  size: PropTypes.oneOf(["normal", "large"]),
  /**
   * Icon to be placed on the left of the text.
   */
  iconLeft: PropTypes.shape({
    assistiveText: PropTypes.string,
    name: PropTypes.string
  }),
  /**
   * Icon to be placed on the right of the text.
   */
  iconRight: PropTypes.shape({
    assistiveText: PropTypes.string,
    name: PropTypes.string
  })
};
Badge.defaultProps = {
  className: undefined,
  variant: undefined,
  size: undefined,
  iconLeft: undefined,
  iconRight: undefined
};
var Badge$1 = Badge;

export { Badge$1 as default };
